import LargeView from './LargeView';

export default LargeView;
